import { defineMessages } from 'react-intl';

const scope = 'promote_input_feedback';

export default defineMessages({
  promotion: {
    id: `${scope}.promotion`,
    defaultMessage:
      'Please type your feedback in below and click send to submit.',
  },
  skipThisAction: {
    id: `${scope}.skip_this_action`,
    defaultMessage: 'No, skip this',
  },
});
